import React from "react";
import { Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from "@mui/material";
import classNames from "classnames";
import { convertGain } from "utils/displayMeasurements";
import { getPercentage, PieChart, pieChartTooltip } from "features/Model/Review/Results/General";

import classes from "./styles.module.scss";

const GainsBreakdown = ({ results = {}, units = "W" }) => {
    const {
        conductiveHeatGain = 0,
        conductiveHeatGainInterior = 0,
        occupantGains = 0,
        baseloadIntGains = 0,
        airChangeHeatGain = 0,
        ventilationHeatGain = 0,
        totalSensHeatGain = 0,
        totalSensLatHeatGain = 0,
    } = results;

    const heatGains = {
        conductive: {
            value: conductiveHeatGain,
            label: "Conductive (Exterior)",
            tooltip: "Conductive Heat Gain (Ext. Components)",
        },
        conductiveInterior: {
            value: conductiveHeatGainInterior,
            label: "Conductive (Interior)",
            tooltip: "Conductive Heat Gain (Int. Components)",
        },
        occupant: {
            value: occupantGains,
            label: "Occupant",
            tooltip: "Occupant Heat Gains",
        },
        baseloadInt: {
            value: baseloadIntGains,
            label: "Base Load Internal",
            tooltip: "Base Load Internal Heat Gains",
        },
        airChange: {
            value: airChangeHeatGain,
            label: "Air Change",
            tooltip: "Air Change Heat Gain",
        },
        ventilation: {
            value: ventilationHeatGain,
            label: "Ventilation",
            tooltip: "Ventilation Heat Gain",
        },
    };

    const heatGainsData = Object.values(heatGains).map(({ label, value, tooltip }) => {
        return [
            label,
            parseFloat(value.toFixed(2)),
            pieChartTooltip(tooltip, convertGain(value, units), units, getPercentage(value, totalSensHeatGain)),
        ];
    });

    return (
        <div className={`${classes.charts}`}>
            <PieChart
                className={classes.pieChart}
                title="Sensible Heat Gains Breakdown"
                data={[
                    ["Heat Gains Type", "Actual", { type: "string", role: "tooltip", p: { html: true } }],
                    ...heatGainsData,
                ]}
            />
            <Table className={classNames(classes.tableContainer)}>
                <TableHead>
                    <TableRow>
                        <TableCell>Heat Gain</TableCell>
                        <TableCell>{units}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Object.values(heatGains).map(({ label, value, tooltip }) => {
                        return (
                            <TableRow key={label}>
                                <TableCell>{tooltip}</TableCell>
                                <TableCell>{convertGain(value, units)}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TableCell>Total Sensible Heat Gain</TableCell>
                        <TableCell>{convertGain(totalSensHeatGain, units)}</TableCell>
                    </TableRow>
                    {/* <TableRow>
                        <TableCell>Total Sensible + Latent Heat Gain</TableCell>
                        <TableCell>{convertGain(totalSensLatHeatGain, units)}</TableCell>
                    </TableRow> */}
                </TableFooter>
            </Table>
        </div>
    );
};

export default GainsBreakdown;